



























import { Component, Vue, Prop } from 'vue-property-decorator';
import { JobSafetyDoc } from '@/models/jobSafetyDocs/jobSafetyDoc';
import Nullable from '@/types/nullable';
import * as JobsAPI from '@/api/jobsApi';
import * as S3API from '@/api/s3Api';

@Component({})
export default class JobSafetyDocs extends Vue {
  @Prop({ type: String, default: null }) public jobID!: string;
  @Prop({ type: Array, default: null }) public jobSafetyDocs!: Nullable<JobSafetyDoc[]>;
  private loading: boolean = false;

  goBack(){
    this.$router.go(-1);
  }

  async downloadSafetyDoc(safetyDocId: number, fileName: string){
    this.loading = true;

    let safetyDoc = await JobsAPI.getSafetyDoc(safetyDocId);

    let result = await S3API.download(safetyDoc.uri);

    let url = window.URL.createObjectURL(new Blob([result.data]));
    let link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    this.loading = false;
  }
  
}

